(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setState(btn, panel, open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.classList.toggle('is-open', open);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ma-footer__toggle');
      if (!btn) return;

      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      setState(btn, panel, !isOpen);

      // parent band karne par andar ke child menus bhi band
      if (isOpen) {
        var openBtns = panel.querySelectorAll('.ma-footer__toggle[aria-expanded="true"]');
        for (var i = 0; i < openBtns.length; i++) {
          var childPanel = document.getElementById(openBtns[i].getAttribute('aria-controls'));
          if (childPanel) setState(openBtns[i], childPanel, false);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
